import {
  ChakraFlex,
  ChakraImage,
  FAIconName,
  FireflyButton,
  Text,
} from '@equip.health/ui';

import errorIllustration from './assets/error-illustration.svg';

interface DashboardCardErrorStateProps {
  variant: 'inline' | 'stacked';
  onReload: () => void;
  isReloading: boolean;
}

const DashboardCardErrorState = ({
  variant,
  onReload,
  isReloading,
}: DashboardCardErrorStateProps) => {
  const isInline = variant === 'inline';

  return (
    <ChakraFlex
      data-testid="dashboard-card-error-state"
      direction={isInline ? 'row' : 'column'}
      alignItems="center"
      justifyContent="center"
      gap="18px"
      padding={isInline ? '12px' : '24px 12px'}
      width="100%"
      height="100%"
      role="alert"
    >
      <ChakraFlex
        direction={isInline ? 'row' : 'column'}
        alignItems="center"
        gap={isInline ? '12px' : '8px'}
        flex={isInline ? '1' : undefined}
      >
        <ChakraImage
          data-testid="error-state-illustration"
          src={errorIllustration}
          alt=""
          width="40px"
          height="40px"
          sx={{ mixBlendMode: 'luminosity' }}
        />
        <ChakraFlex
          direction="column"
          gap="4px"
          alignItems={isInline ? 'flex-start' : 'center'}
          textAlign={isInline ? 'left' : 'center'}
        >
          <Text variant="h5" color="neutral.secondary">
            Unable to load
          </Text>
          <Text
            variant="caption"
            color="neutral.secondary"
            maxWidth={isInline ? undefined : '320px'}
          >
            We encountered a problem while loading your data. Please reload this
            section or try again later.
          </Text>
        </ChakraFlex>
      </ChakraFlex>
      <FireflyButton
        id={`error-state-reload-button-${variant}`}
        variant="secondary"
        size="small"
        leftIcon={FAIconName.arrowsRotateRegular}
        isLoading={isReloading}
        onClick={onReload}
      >
        Reload
      </FireflyButton>
    </ChakraFlex>
  );
};

export default DashboardCardErrorState;
